(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@skype/tsregistrar"));
	else if(typeof define === 'function' && define.amd)
		define("@skype/tstrouter", ["@skype/tsregistrar"], factory);
	else if(typeof exports === 'object')
		exports["@skype/tstrouter"] = factory(require("@skype/tsregistrar"));
	else
		root["@skype/tstrouter"] = factory(root["@skype/tsregistrar"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_21__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition